export const getMaNavigation = (state) => state.maNavigation;
export const getNotificationsLink = (state) =>
  getMaNavigation(state).notificationsLink;
